export default {
  loginTitle: '다시 오신 것을 환영합니다',
  loginSubtitle: '계정에 로그인하세요',
  signupTitle: '회원가입',
  signupSubtitle: '새 계정을 만들어보세요',
  email: '이메일',
  password: '비밀번호',
  loginButton: '로그인',
  signupButton: '회원가입',
  processing: '처리 중...',
  switchToLogin: '이미 계정이 있으신가요? 로그인',
  switchToSignup: '계정이 없으신가요? 회원가입',
  backToHome: '홈으로 돌아가기',
  loginSuccess: '로그인 성공!',
  signupSuccess: '회원가입이 완료되었습니다! 이메일을 확인해주세요.',
  errors: {
    invalidCredentials: '이메일 또는 비밀번호가 올바르지 않습니다',
    emailNotConfirmed: '이메일 인증이 필요합니다',
    userExists: '이미 가입된 이메일입니다',
    general: '오류가 발생했습니다',
  },
};
